<div class="wrapper" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
  <!-- Quantity setter -->
  <button
    class="quantity-setter"
    *ngIf="canDisplayQuantitySetter$ | async"
    (click)="onClickQuantitySetter(); $event.stopPropagation()"
    [disabled]="(isLoading$ | async) || !(canChangeQuantity$ | async)"
    [ngClass]="'quantity-setter--' + size"
  >
    <span class="quantity">
      <ng-container *ngIf="!(isLoading$ | async); else loadingSpinner">
        <!--
          If promotion code is set, it means that the it's a cart line of a promotion.
          If it's the case, we display the quantity of the cart line in the promotion.
          Otherwise, we display the quantity of the product in the cart.
          This is because we identify a cart line by its product id and its promotion code.
          If there is a promotion with the same product twice, we can't know identify the cart line.
        -->
        {{ promotionCode === '' || promotionCode == null ? (cartLineQuantity$ | async) : $any(product).quantity }}
      </ng-container>
      <ng-template #loadingSpinner>
        <img
                class="button__loading-spinner"
                src="assets/img/spinner-green.png"
                alt="button spinner"
        />
      </ng-template>
    </span>
    <button class="arrow-button" *ngIf="canChangeQuantity$ | async">
      <svg-icon class="arrow-icon" src="./assets/icons/down.svg"></svg-icon>
    </button>
  </button>

  <!-- Add to cart -->
  <button
    *ngIf="canDisplayAddButton$ | async"
    customButton
    expand="full"
    (click)="onClickAddButton(); $event.stopPropagation()"
    [size]="size"
    [disabled]="isLoading$ | async"
    [isLoading]="isLoading$ | async"
  >
    <span class="price-text" *ngIf="showPrice">
      {{ product?.price | localizedCurrency }}
    </span>
    <span>
      {{
        size === "large"
          ? ("add_to_cart_button.add_to_cart" | translate)
          : ("add_to_cart_button.add" | translate)
      }}
    </span>
  </button>

  <!-- See price -->
  <button
    *ngIf="canDisplaySeePrice$ | async"
    customButton
    expand="full"
    appearance="ghost"
    [size]="size"
    (click)="onClickSeePrice(); $event.stopPropagation()"
  >
    {{ "add_to_cart_button.see_price" | translate }}
  </button>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="dropdownIsOpen"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayPositionStrategy]="overlayPosition"
  (backdropClick)="onClickDropdown()"
>
  <app-dropdown-quantity-selector
    class="dropdown-panel"
    (onSelectedQuantity)="changeQuantity($event); dropdownIsOpen = false"
  ></app-dropdown-quantity-selector>
</ng-template>
